import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {CompanyEventsListManagerService} from "../../company-events-list-manager.service";
import {CurrencyPipe, DatePipe} from "@angular/common";
import {DateTimeService} from "../../../../services/date-time.service";

@Component({
    selector: 'company-events-list-tile',
    templateUrl: './company-events-list-tile.component.html',
    styleUrls: ['./company-events-list-tile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CompanyEventsListTileComponent {
  @Input() event: any;
  @Input() type: any;
  @Input() isLast: boolean;
  showInfoBar: boolean = false;
  constructor(public listManager: CompanyEventsListManagerService, private datePipe: DatePipe, private currencyPipe: CurrencyPipe, private dateTimeService: DateTimeService) {
  }

  getStyle(){
    return this.type.toLowerCase().split(" ").join("-")
  }
  getHeaderStyle(){
    return 'tile-' + this.type.toLowerCase().split(" ").join("-")
  }
  getStatusCount(){
    let count = 0;
    let modifiers = ['is_sponsored', 'is_cancelled', 'is_cosponsored', 'is_postponed']
    for (let k of Object.keys(this.event.companyEvent)){
        if(modifiers.includes(k) && this.event.companyEvent[k] == true){
          count += 1;
        }
    }
    return count;
  }

  getAttendeeString(){
    let string = ""
    if(this.event.companyEvent.companyEventAttendees.length > 0){
      for(let i=0; i < this.event.companyEvent.companyEventAttendees.length; i++){
        let person = this.event.companyEvent.companyEventAttendees[i].person.name;
        string += person;
        if(this.event.companyEvent.companyEventAttendees.length > 1 &&
        i < this.event.companyEvent.companyEventAttendees.length - 1){
          string += ", "
        }
      }
    }
    return string;
  }

  renderDates(){
    let dateVar = {
      'start_date': this.event.start_date,
      'end_date': this.event.end_date,
      'start_time': this.event.start_time,
      'end_time': this.event.end_time,
      'timezone': this.event.timezone,
    }
    let suffixString = (day:number) => {
      if (day >= 11 && day <= 13) {
        return 'th';
      }
      switch (day % 10) {
        case 1:
          return 'st';
        case 2:
          return 'nd';
        case 3:
          return 'rd';
        default:
          return 'th';
      }
    }

    let dateObj = this.dateTimeService.formatCompanyEventTimes(dateVar)
    let hasStartTime = dateObj.viewStart?.length>0;
    let hasEndTime = dateObj.viewEnd?.length>0;
    let hasEndDate = dateObj.endDate!==null;
    let sameDate = dateObj.startDate == dateObj.endDate
    let startstr = this.datePipe.transform(dateObj.startDate, 'd')
    startstr = startstr + suffixString(Number(this.datePipe.transform(dateObj.startDate, 'd')))
    if(hasEndDate && !sameDate){
      startstr += " - "
      startstr += this.datePipe.transform(dateObj.endDate,'d') ?? ""
      startstr += suffixString(Number(this.datePipe.transform(dateObj.endDate, 'd')))
    }
    return startstr
  }

  renderTimes(){
    let dateVar = {
      'start_date': this.event.start_date,
      'end_date': this.event.end_date,
      'start_time': this.event.start_time,
      'end_time': this.event.end_time,
      'timezone': this.event.timezone,
    }
    let dateObj = this.dateTimeService.formatCompanyEventTimes(dateVar)
    let hasStartTime = dateObj.viewStart?.length>0;
    let hasEndTime = dateObj.viewEnd?.length>0;
    let timeStr = ""
    if(hasStartTime){
      timeStr += this.datePipe.transform(dateObj.startDate + " " + dateObj.viewStart, 'h:mm a')
    }
    if(hasEndTime){
      timeStr += " - "
      timeStr += this.datePipe.transform(dateObj.startDate + " " + dateObj.viewEnd, 'h:mm a')
    }
    if(hasEndTime || hasStartTime){
      timeStr += " " + this.dateTimeService.timezones.find((tz) => tz.tz == dateObj.timezone)?.abbr;
    }
    return timeStr;
  }

  renderEventInfo(){
    let companyEvent = this.event.companyEvent
    let infoArr = []
    infoArr.push({key: 'type', value: companyEvent.companyEventType.name})
    let addresses = <any>[]
    for(let e = 0; e < companyEvent.companyEventAddresses.length; e++){
      let data = companyEvent.companyEventAddresses[e]
      let addrString = data.address.address1;
      addrString += data.address.address2 ? " " + data.address.address2 : ", "
      addrString += data.address.zipCode.city + ", "
      addrString += data.address.zipCode.state.abbreviation + " "
      addrString += data.address.zipCode.zipcode
      let address = {name: data.name, address: addrString}
      addresses.push(address)

    }
    let registered = [];
    let unregistered = [];
    for(let g = 0; g < companyEvent.companyEventAttendees.length; g++){
      let attendee = companyEvent.companyEventAttendees[g]
      if(attendee.is_registered){
        registered.push(attendee)
      } else {
        unregistered.push(attendee)
      }
    }
    infoArr.push({key: 'location', value: addresses})
    infoArr.push({key: 'registered', value: registered.sort((a,b) => {
      if (a.person.name < b.person.name) return -1;
      if (a.person.name > b.person.name) return 1;
      return 0
    })})
    infoArr.push({key: 'unregistered', value: unregistered.sort((a,b) => {
      if(a.person.name < b.person.name) return -1;
      if(a.person.name > b.person.name) return 1;
      return 0;
    })})
    let statuses = <any>[]
    if(companyEvent.is_sponsored && companyEvent.sponsorship_amount!==null){
      statuses.push({status: 'is_sponsored', value: this.currencyPipe.transform(companyEvent.sponsorship_amount, 'USD', "symbol","1.0-0")})
    }
    if(companyEvent.is_cosponsored && companyEvent.cosponsor!==null){
      statuses.push({status: 'is_cosponsored', value: companyEvent.cosponsor})
    }
    if(companyEvent.is_cancelled){
      statuses.push({status: 'is_cancelled', value: null})
    }
    if(companyEvent.is_postponed){
      statuses.push({status: 'is_postponed', value: null})
    }
    infoArr.push({key: 'status', value: statuses})
    return infoArr
  }

  showHideInfoSection(){
    this.showInfoBar = !this.showInfoBar
  }

  onHoverLeave(){
    this.showInfoBar = false
  }

}
